'use client';
import { Row } from '../../styles/common-styles';
import { TitleMedium, BodyLarge } from '../../styles';
import { BoxProps } from '@mui/material';
import { ToolTip } from '../tooltip/Tooltip';

interface IntroProps extends BoxProps {
    title: string;
    description: string;
    showTooltip?: boolean;
    showDescription?: boolean;
}
const Intro = ({
    title,
    description,
    showTooltip = false,
    showDescription = false,
    ...boxProps
}: IntroProps) => {
    return (
        <>
            <Row {...boxProps}>
                <TitleMedium>{title}</TitleMedium>
                {showTooltip ? <ToolTip content={description} /> : null}
            </Row>
            {showDescription ? <BodyLarge>{description}</BodyLarge> : null}
        </>
    );
};

export { Intro };
